module.exports = __webpack_public_path__ + "static/media/red-dot.59f38d2e.svg";